import './main.css';
import './utils/storefront/shopify';
import './utils/web-components/details-accordion';
import './utils/web-components/sidebar-menu';
import './utils/web-components/header-search';
import './utils/web-components/search-form';
import './utils/web-components/predictive-search';
import './utils/web-components/quantity-input';
import './utils/web-components/swatch-selector';
import './utils/web-components/product-quantity-selector';
import './utils/web-components/cart-items';
import './utils/web-components/cart-drawer';
import './utils/web-components/cart-drawer-items';
import './utils/web-components/cart-drawer-note';
import './utils/web-components/cart-remove-button';
import './utils/web-components/cart-note';
import './utils/web-components/fade-in';
import { register } from 'swiper/element/bundle';
import Layout from 'utils/layout';
import Video from 'utils/video';

register();

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = Layout.getInstance();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`).then((m) => {
      const module = m.default;
      const { webcomponent } = m;
      const modules = [...sections].filter(
        (section) => section.dataset.section === name,
      );
      modules.forEach((element) => {
        const dataEl = element.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = element.querySelectorAll('[data-component="video"]');
        const videos =
          videoEls &&
          [...videoEls].map(
            (videoEl) => new Video({ element, video: videoEl, layout }),
          );

        if (!webcomponent && typeof module === 'function') {
          module(element, { ...data, layout, videos });
        } else if (webcomponent && typeof module === 'function') {
          if (!customElements.get(webcomponent)) {
            customElements.define(webcomponent, module);
          }
        } else {
          // eslint-disable-next-line no-console
          console.warn(
            // eslint-disable-next-line max-len
            `Module for ${name} does not have a default export or a webcomponent export`,
          );
        }
      });
    });
  });
})();
